'use strict';

module.exports = {
  CONTAINER_HEIGHT_SCALE_FACTOR: 'containerHeightScaleFactor'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-infinite/build/utils/scaleEnum.js
// module id = 687
// module chunks = 0 1 2